import { useState, useEffect } from 'react';

const TERMS_NOTICE_KEY = 'termsNoticeAcknowledged';
const TERMS_NOTICE_VERSION = '1.0'; // Increment this if you need to show the notice again

export const useTermsNotice = () => {
  const [showTermsNotice, setShowTermsNotice] = useState(false);

  useEffect(() => {
    // Check if user has already acknowledged the terms notice
    const acknowledged = localStorage.getItem(TERMS_NOTICE_KEY);
    const acknowledgedVersion = localStorage.getItem(`${TERMS_NOTICE_KEY}_version`);
    
    // Show notice if never acknowledged or if version is different
    if (!acknowledged || acknowledgedVersion !== TERMS_NOTICE_VERSION) {
      setShowTermsNotice(true);
    }
  }, []);

  const acknowledgeTermsNotice = () => {
    localStorage.setItem(TERMS_NOTICE_KEY, 'true');
    localStorage.setItem(`${TERMS_NOTICE_KEY}_version`, TERMS_NOTICE_VERSION);
    setShowTermsNotice(false);
  };

  const resetTermsNotice = () => {
    localStorage.removeItem(TERMS_NOTICE_KEY);
    localStorage.removeItem(`${TERMS_NOTICE_KEY}_version`);
    setShowTermsNotice(true);
  };

  return {
    showTermsNotice,
    acknowledgeTermsNotice,
    resetTermsNotice
  };
};
